import React from 'react';
import './StatementItem.style.css';

interface StatementItemProps {
  title: string;
  count?: number | null;
  size?: number;
  gap?: number;
  children: React.ReactNode;
  titleStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

const StatementItem: React.FC<StatementItemProps> = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    title = '',
    count = null,
    children = null,
    size = 20,
    gap = 8,
    titleStyle = {},
    containerStyle = {},
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="statement-item" style={{ gap: gap, ...containerStyle }}>
      <h2 style={{ fontSize: size, ...titleStyle }}>
        {title} {typeof count === 'number' ? `(${count}건)` : null}
      </h2>
      {children}
    </div>
  );
};

export default StatementItem;
